import React, { useEffect, useState } from "react";
import { Builder } from "@builder.io/sdk";
import SignUpForm from "./SignUpFormUI/SignUpForm/SignUpForm";
import {
  SignUpFormType,
  BuilderState,
} from "./SignUpFormTypes/signUpFormTypes";
import usePromoCodeSignUpForm from "./usePromoCodeSignUpForm";
import { dbEmailExists } from "./helpers/dbEmailExists";
import { useSignUpFormState } from "./helpers/hooks/useSignUpFormState";
import { signUpStepCompleted } from "./helpers/signUpStepCompleted";
import { onSubmitForm } from "./helpers/submitForm";
import { useSpecialties } from "@hooks/useSpecialties";
import useOtherProfessionQuery from "./helpers/hooks/useOtherProfession.query";
import useSignUpTermsQuery from "./helpers/hooks/useSignUpTerms.query";
import { Cookie } from "../../../utils/Cookie";
import SignUpFormWrapperOptions from "./signUpFormWrapperOptions";
import SPfetch from "../../../services/SPFetch.class";
import { segmentTrack } from "@utils/segment/segment-track";

const SignUpFormWrapper: React.FC<SignUpFormType & BuilderState> = ({
  steps,
  lastStepCta,
  includeClientPractitionerSelection,
  clientPractitionerSelection,
  ...props
}) => {
  const promoCode = props?.builderState?.content?.data?.promoCode;
  const promoCodeInfo = usePromoCodeSignUpForm(promoCode);
  const methods = useSignUpFormState(state => state);
  const handleSetCookie = (cname: string, cvalue: string) => {
    Cookie.setCookie(cname, cvalue, 365);
  };

  const deleteCookieFromBaseDomain = (name: string) => {
    document.cookie = `${name}=; Path=/; domain=.simplepractice.com; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  };

  const onStepZeroClick: (type: string, target: string | null) => void = (
    type,
    target
  ) => {
    segmentTrack("Marketing CTA User Differentiation Clicked", {
      type_selected: type,
      url: window.location.pathname,
      target: target,
    });
  };

  steps &&
    steps.forEach(step => {
      if (!step.fields) step.fields = [];
    });

  // Grab global practitioner data for optional step zero
  const [practitionerData, setPractitionerData] = useState(null);

  useEffect(() => {
    (async () => {
      const data = await SPfetch.get(
        `https://cdn.builder.io/api/v3/content/global-options?apiKey=${process.env.GATSBY_BUILDER_REBRAND_API_KEY}`
      );

      const { globalClientPractitionerSelection } = data.results[0].data;

      setPractitionerData({
        ...globalClientPractitionerSelection,
        clientPractitionerSelectionHeader:
          clientPractitionerSelection?.clientPractitionerSelectionHeader,
      });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SignUpForm
      steps={steps}
      lastStepCta={lastStepCta}
      promoCodeInfo={promoCodeInfo}
      dbEmailExists={dbEmailExists}
      useSignUpFormStateMethods={methods}
      handleSetCookie={handleSetCookie}
      deleteCookieFromBaseDomain={deleteCookieFromBaseDomain}
      onSubmitForm={onSubmitForm}
      useSpecialties={useSpecialties}
      useOtherProfessionQuery={useOtherProfessionQuery}
      useSignUpTermsQuery={useSignUpTermsQuery}
      signUpStepCompleted={signUpStepCompleted}
      includeClientPractitionerSelection={includeClientPractitionerSelection}
      clientPractitionerSelection={practitionerData}
      onStepZeroClick={onStepZeroClick}
    />
  );
};

export default SignUpFormWrapper;

export const RegisterSignUpFormWrapper = () => {
  Builder.registerComponent(SignUpFormWrapper, SignUpFormWrapperOptions);
};
